// extracted by mini-css-extract-plugin
export default {"list":"Skills_list__nw6Ok","placeholder":"Skills_placeholder__MnnJe","row":"Skills_row__-YhpW"};